module["exports"] = [
  "### عمارة",
  "### طابق"
];
